// extracted by mini-css-extract-plugin
export default {"container":"LogoIcon_container__wXLQ3","img":"LogoIcon_img__jIYwK"};